(function () {
  var FILTER_ALIASES = {
    Surveillance: ['surveillance', 'intelligence & surveillance'],
    'Government Surveillance': ['government surveillance'],
    'Cyber Warfare': ['cyber warfare'],
    'Must Watch': ['must watch'],
    'Privacy & Security': ['privacy & security', 'data breach', 'data brokers', 'privacy guide'],
  };

  function normalizeCategory(value) {
    return (value || '').trim().toLowerCase();
  }

  function categoryMatchesFilter(category, filter) {
    if (!filter) return true;

    var normalized = normalizeCategory(category);
    var aliases = FILTER_ALIASES[filter];

    if (aliases) {
      return aliases.indexOf(normalized) !== -1;
    }

    return normalizeCategory(filter) === normalized;
  }

  function initFeatured(section) {
    if (!section) return;

    var state = {
      activeTab: 0,
      currentPage: 1,
      pageSize: Number(section.getAttribute('data-page-size') || 10),
    };

    function getTabs() {
      return Array.prototype.slice.call(section.querySelectorAll('[data-featured-tab]'));
    }

    function getFeaturedStory() {
      return section.querySelector('[data-featured-story]');
    }

    function getStoryRows() {
      return Array.prototype.slice.call(section.querySelectorAll('[data-story-row]'));
    }

    function activeFilter() {
      var tabs = getTabs();
      var tab = tabs[state.activeTab];
      return tab ? tab.getAttribute('data-filter') || '' : '';
    }

    function filteredRows() {
      var filter = activeFilter();
      return getStoryRows().filter(function (row) {
        if (row.getAttribute('data-featured') === 'true') return false;
        return categoryMatchesFilter(row.getAttribute('data-category'), filter);
      });
    }

    function renderPageNumbers(totalPages) {
      var pageNumbers = section.querySelector('[data-page-numbers]');
      if (!pageNumbers) return;

      pageNumbers.innerHTML = '';

      for (var page = 1; page <= totalPages; page += 1) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'ghost-featured__page-number' + (page === state.currentPage ? ' is-active' : '');
        button.setAttribute('data-page-number', String(page));
        button.setAttribute('aria-current', page === state.currentPage ? 'page' : 'false');
        button.textContent = String(page);
        pageNumbers.appendChild(button);
      }
    }

    function render() {
      var filter = activeFilter();
      var featured = getFeaturedStory();
      var allRows = getStoryRows();
      var rows = filteredRows();
      var featuredTop = section.querySelector('[data-featured-top-wrap]');
      var featuredSlot = section.querySelector('[data-featured-slot]');
      var pagination = section.querySelector('[data-featured-pagination]');
      var pageLabel = section.querySelector('[data-featured-page-label]');
      var emptyState = section.querySelector('[data-featured-empty]');
      var showFeatured = !filter && state.currentPage === 1 && featured;
      var totalPages = Math.max(1, Math.ceil(rows.length / state.pageSize));

      if (state.currentPage > totalPages) state.currentPage = totalPages;

      if (featuredTop) featuredTop.hidden = !showFeatured;
      if (featuredSlot) featuredSlot.hidden = !showFeatured;
      if (featured) featured.hidden = !showFeatured;

      allRows.forEach(function (row) {
        row.hidden = true;
      });

      var start = (state.currentPage - 1) * state.pageSize;
      var visibleRows = rows.slice(start, start + state.pageSize);
      visibleRows.forEach(function (row) {
        row.hidden = false;
      });

      if (emptyState) {
        emptyState.hidden = showFeatured || visibleRows.length > 0;
      }

      if (pageLabel) {
        if (totalPages > 1) {
          pageLabel.textContent = 'Page ' + state.currentPage + ' of ' + totalPages;
          pageLabel.hidden = false;
        } else {
          pageLabel.hidden = true;
        }
      }

      if (pagination) {
        pagination.hidden = totalPages <= 1;
        renderPageNumbers(totalPages);

        var prev = pagination.querySelector('[data-page-prev]');
        var next = pagination.querySelector('[data-page-next]');
        if (prev) prev.disabled = state.currentPage === 1;
        if (next) next.disabled = state.currentPage === totalPages;
      }
    }

    function setActiveTab(index) {
      var tabs = getTabs();
      if (!tabs.length || index < 0 || index >= tabs.length) return;

      state.activeTab = index;
      state.currentPage = 1;

      tabs.forEach(function (item, itemIndex) {
        var isActive = itemIndex === state.activeTab;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      render();
    }

    function onSectionActivate(event) {
      if (event.type === 'pointerup' && event.button !== 0) return;
      if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
      if (event.type === 'keydown') event.preventDefault();

      var tab = event.target.closest('[data-featured-tab]');
      if (tab && section.contains(tab)) {
        var tabs = getTabs();
        var index = tabs.indexOf(tab);
        if (index !== -1) setActiveTab(index);
        return;
      }

      var target = event.target.closest('[data-page-number], [data-page-prev], [data-page-next]');
      if (!target || !section.contains(target)) return;

      if (target.hasAttribute('data-page-prev')) {
        state.currentPage = Math.max(1, state.currentPage - 1);
      } else if (target.hasAttribute('data-page-next')) {
        state.currentPage += 1;
      } else {
        state.currentPage = Number(target.getAttribute('data-page-number') || 1);
      }

      render();
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    if (section.dataset.ghostFeaturedInit !== '2') {
      section.dataset.ghostFeaturedInit = '2';
      section.addEventListener('click', onSectionActivate);
      section.addEventListener('pointerup', onSectionActivate);
      section.addEventListener('keydown', onSectionActivate);
    }

    section.__ghostFeaturedRender = render;
    render();
  }

  function initAll() {
    document.querySelectorAll('[data-ghost-featured]').forEach(initFeatured);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-ghost-featured]');
    if (section) initFeatured(section);
  });
})();
